import {useFieldContext} from '../../utils/formContext';

import {MultiTextInput} from './MultiTextInput';

type Props = Omit<
  React.ComponentProps<typeof MultiTextInput>,
  'name' | 'value' | 'onChange' | 'onBlur' | 'error'
>;
export function FormMultiTextInput(props: Props): React.JSX.Element {
  const field = useFieldContext<string>();

  return (
    <MultiTextInput
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      error={field.state.meta.errors.map((e) => e.message).join(', ')}
    />
  );
}
